import { Middleware } from 'redux';
import { RootState } from 'store/reducer';
import { getFiltersPinned, getAllFilters } from 'store/visits/selectors';
import { saveFiltersToStorage } from 'store/visits/util';

const filterActions = [
  'visits/SET_SEARCH_FILTER',
  'visits/SET_STATUS_FILTER',
  'visits/SET_COMPANY_FILTER',
  'visits/SET_HOST_FILTER',
  'visits/CLEAR_FILTERS',
];

export const saveFiltersMiddleware: Middleware<Record<string, unknown>, RootState> = (store) => (next) => (action) => {
  const result = next(action);

  // Save filters to localStorage if pinned and a filter action was dispatched
  if (filterActions.includes(action.type)) {
    const state = store.getState();
    if (getFiltersPinned(state)) {
      const filters = getAllFilters(state);
      saveFiltersToStorage(filters);
      // Update pinned state to reflect that filters are now in localStorage
      // This ensures the state stays in sync
    }
  }

  return result;
};
